import React, { useCallback } from 'react';
import styles from './LessonHeader.module.scss';
import Button from '../../../components/button/Button';
// import { useCourseContent } from '../../../hooks/useCourseContent';
import { getMediaAbsolutePath } from '../../../services/File';
// import { Content } from 'src/types';

type Props = {
  name: string;
  description?: string;
  image?: string;
};

function LessonHeader(props: Props) {
  const { name, image, description } = props;

  // const { lesson, setContent, setSelectionLevel } = useCourseContent();

  const handleOpenTeacherPreparation = useCallback(() => {
    // const newContent = lesson?.teacherPreparation?.[0];
    // if (newContent) {
    //   setContent(newContent as Content);
    //   setSelectionLevel('Content')
    // }
    // }, [lesson?.teacherPreparation, setContent, setSelectionLevel]);
  }, []);

  const handleOpenClassPresentation = useCallback(() => {
    // const newContent = lesson?.classPresentation?.[0];
    // if (newContent) {
    //   setContent(newContent as Content);
    //   setSelectionLevel('Content')
    // }
    // }, [lesson?.classPresentation, setContent, setSelectionLevel]);
  }, []);

  return (
    <div className={styles.header}>
      {image ? <>
          <div className={styles.headerContent}>
            <div className={styles.headerTitle}>{name}</div>
            {description && <div className={styles.headerDescription}>{description}</div>}
          </div>
          <div className={styles.contentImage}>
            <div className={styles.image} style={{ backgroundImage: `url(${getMediaAbsolutePath(image)})` }}/>
            <div className={styles.actions}>
              <Button onClick={handleOpenTeacherPreparation} label={'View Preparation'} type="button"/>
              <Button onClick={handleOpenClassPresentation} label={'Begin Lesson'} type="button"/>
            </div>
          </div>
        </> :
        <div className={styles.headerContent}>
          <div className={styles.headerTitle}>{name}</div>
          {description && <div className={styles.headerDescription}>{description}</div>}
          <div className={styles.actions}>
            <Button onClick={handleOpenTeacherPreparation} label={'View Preparation'} type="button"/>
            <Button onClick={handleOpenClassPresentation} label={'Begin Lesson'} type="button"/>
          </div>
        </div>
      }
    </div>
  );
}

export default LessonHeader;
